module.exports = __webpack_public_path__ + "static/liva-convert-detail5-8cbc5a55ba73e802086f206839149e6c.png";